import * as React from 'react';
import styles from './productStockGeneralError.module.css';
import { Icon } from '../../icon';
export const ProductStockGeneralError = ({ message, }) => (React.createElement("div", { className: styles.ProductStockGeneralError },
    React.createElement(Icon, { icon: "BASKET_EMPTY", size: "s", classes: styles.ProductStockGeneralErrorIcon }),
    message));
